// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ConsultingCaseListListResultModel from '../../model/consulting-case-list-list-result-model';
import ConsultingCaseListListResultDTO from '../dto/consulting-case-list-list-result-dto';
import dtoSchema from '../schemas/consulting-case-list-list-result-schema';
import ConsultingCaseListModel from '../../model/consulting-case-list-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class ConsultingCaseListListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ConsultingCaseListListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ConsultingCaseListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: ConsultingCaseListModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<ConsultingCaseListListResultDTO>): ConsultingCaseListListResultModel;
  static toModel(dto: DeepPartial<ConsultingCaseListListResultDTO> | undefined | null): ConsultingCaseListListResultModel | undefined;
  static toModel(dto: DeepPartial<ConsultingCaseListListResultDTO> | undefined | null): ConsultingCaseListListResultModel | undefined {
    return dto ? new ConsultingCaseListListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ConsultingCaseListListResultModel> | ConsultingCaseListListResultModel): ConsultingCaseListListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as ConsultingCaseListListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ConsultingCaseListListResultModel, can not map to ConsultingCaseListListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
